import React from 'react';
import { Table } from 'reactstrap';

import { changeRequestShape } from '../../prop-types';
import { getCampaignDiff } from '../utils';

function ChangeMerchantExclusivityComment({ changeRequest }) {
  const diffObject = getCampaignDiff(changeRequest);
  const draftCampaign = changeRequest.draftCampaigns[0];
  if (!diffObject) {
    return null;
  }
  const { merchantExclusivity } = diffObject;

  const currentMerchantExclusivity = merchantExclusivity
    ? merchantExclusivity.originValue
    : draftCampaign.merchantExclusivity;

  const newMerchantExclusivity = merchantExclusivity
    ? merchantExclusivity.draftValue
    : '';

  return (
    <Table striped size="sm" className="mb-2 small">
      <thead>
        <tr>
          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
          <th className="border-top-0" />
          <th className="border-top-0">Merchant Exclusivity</th>
        </tr>
      </thead>
      <tbody>
        <tr className="qa-current">
          <td>Current</td>
          <td>{currentMerchantExclusivity}</td>
        </tr>
        <tr className="qa-new">
          <td>New</td>
          <td>{newMerchantExclusivity}</td>
        </tr>
      </tbody>
    </Table>
  );
}

ChangeMerchantExclusivityComment.propTypes = {
  changeRequest: changeRequestShape.isRequired,
};

export default ChangeMerchantExclusivityComment;
